import { render } from "./ChatView.vue?vue&type=template&id=8b85906e&scoped=true&ts=true"
import script from "./ChatView.vue?vue&type=script&lang=ts"
export * from "./ChatView.vue?vue&type=script&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=8b85906e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b85906e"]])

export default __exports__